import auth from "./auth";
import userProfile from './user-dashboard/user-profile.js'
import general from "./general";
import web from "@/api/web/web";
import teams from "@/api/user-dashboard/teams";
import events_dashboard from "@/api/user-dashboard/events_dashboard";
import notification from "@/api/user-dashboard/notification/notification";


export default {
    auth,
    userProfile,
    general,
    web,
    teams,
    events_dashboard,
    notification
}